import { object } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { topic } from './shared/topic'
import { brandVoiceId, tone } from './shared/voiceTones'
import { links } from './shared/links'
import { avoid } from './shared/avoid'
import { audience } from './shared/audience'
import { language } from './shared/language'
import { Instagram } from 'blaze-ui/icons'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { includeImages } from './shared/includeImages'
import { postLength } from './shared/postLength'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { PostLength } from '../ContentPlanning/utils'
import { crossPostAccounts } from './shared/crossPostAccounts'
import { brandKitId } from './shared/brandKitId'
import { TextChannels } from '../../../constants'
import { includeEmojis } from './shared/includeEmojis'

const meta = {
  type: ChannelType.InstagramPosts,
  icon: Instagram,
  steps: ['Context', 'Generate Post'],
  title: TextChannels[ChannelType.InstagramPosts].name,
  submitLabel: 'Generate Post',
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183790/Home%20Card%20Previews/zapgd34o7xuxuf368iqd.png',
}

const fields = {
  topic: topic.meta({ label: 'What is the topic of your Instagram post?', generationType: meta.type }),
  include_emojis: includeEmojis,
  audience: audience.required().meta({ label: 'Who is the target audience?' }),
  post_length: postLength
    .required()
    .oneOf([
      PostLength.FiveToTenWords,
      PostLength.TenToTwentyFiveWords,
      PostLength.TwentyFiveToFiftyWords,
      PostLength.FiftyToSeventyFiveWords,
      PostLength.SeventyFivetoOneHundredWords,
      PostLength.OneHudredPlusWords,
    ])
    .default(PostLength.TenToTwentyFiveWords),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  source_material_ids: sourceMaterialIds,
  tone,
  language,
  include_images: includeImages.meta({
    description: 'An image will make your posts far more engaging and attention grabbing',
  }),
  cross_post_accounts: crossPostAccounts,
  links: links.meta({ collapsible: true }),
  avoid: avoid.meta({ collapsible: true }),
}

export const InstagramPostsSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>

export const InstagramPostsMultiStepSchema: MultiStepSchema<ChannelType.InstagramPosts> = {
  steps: [
    InstagramPostsSchema.omit(['include_images']).meta({
      title: 'Purpose & Goals',
      submitLabel: 'Select Images',
    }) as StepSchema,
    SelectImages.meta({ submitLabel: meta.submitLabel, type: meta.type }) as StepSchema,
  ],
  meta: {
    ...meta,
    type: ChannelType.InstagramPosts,
    channel: ChannelType.InstagramPosts,
  },
}
